var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{staticClass:"mx-2",attrs:{"color":_vm.activeDevice ? '' : 'red',"disabled":_vm.disabled,"dark":"","fab":"","outlined":""},on:{"click":function($event){return _vm.emitToggleDevice()}}},[_c('v-icon',[_vm._v(_vm._s(_vm.activeDevice ? _vm.iconName : `${_vm.iconName}_off`))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }